import { LookupValue } from "./lookup.models";

export class BillChangeType extends LookupValue {
	isSavings: boolean;
	canOffer: boolean;
	isClaimable: boolean;
	canClientClaim: boolean;
}
